module.exports = __webpack_public_path__ + "img/pr-4.46b3e385.png";